import axios from 'axios';

// const BASE_URL = 'http://localhost:5000/api';
const BASE_URL = process.env.REACT_APP_API_URL;

// Get auth token from localStorage
const getAuthToken = () => {
    const userInfo = localStorage.getItem('userInfo');
    return userInfo ? JSON.parse(userInfo).token : null;
};

// Get admin token from localStorage
const getAdminToken = () => {
    const adminInfo = localStorage.getItem('adminUserData');
    return adminInfo ? JSON.parse(adminInfo).token : null;
};

// Create axios instance with auth header
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Create axios instance with auth header
const adminApi = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

// Add response logging and 401 error handling
api.interceptors.response.use(
    (response) => {

        return response;
    },
    (error) => {
        // Handle 401 Unauthorized errors
        if (error.response && error.response.status === 401) {
            // Clear user data from localStorage
            localStorage.removeItem('userInfo');
            // Redirect to login page
            if (window.location.pathname !== '/login' && window.location.pathname !== '/register') {
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);


// Add auth token to admin requests
adminApi.interceptors.request.use((config) => {
    const token = getAdminToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

// Add response logging for admin requests
adminApi.interceptors.response.use(
    (response) => {

        return response;
    },
    (error) => {

        return Promise.reject(error);
    }
);

export { api, adminApi };
export { getAuthToken, BASE_URL }; 